var map = {
	"./ar.svg": 20172,
	"./de.svg": 2308,
	"./en.svg": 37772,
	"./es.svg": 36317,
	"./fr.svg": 30085,
	"./hi.svg": 90684,
	"./it.svg": 53734,
	"./ja.svg": 32474,
	"./km.svg": 4657,
	"./my.svg": 5683,
	"./pt.svg": 88805,
	"./ru.svg": 56326,
	"./sa.svg": 20165,
	"./sk.svg": 85475,
	"./sw.svg": 50071,
	"./tr.svg": 25171,
	"./ur.svg": 70536,
	"./vi.svg": 99958,
	"./zh.svg": 97871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83778;